export const TipoAulaEnum = {
  VIDEO: 'VIDEO',
  ESCRITA: 'ESCRITA',
  QUESTIONARIO: 'QUESTIONARIO'
};
